import React from "react";
import styled from "styled-components";

const Panel = styled.div`
    width: 100%;
`

const Header = styled.button`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    text-align: left;
    font-family: 'Helvetica Neue', Helvetica, Arial, Sans-Serif;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #8a8a8a;
`

const Title = styled.span`
    flex-shrink: 0;
`

const Divider = styled.span`
    flex: 1;
    height: 1px;
    background: #e6e6e6;
`

const Chevron = styled.span`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease;
    transform: ${({ $open }) => ($open ? "rotate(180deg)" : "rotate(0deg)")};
`

const Body = styled.div`
    margin-top: 12px;
`

const CollapsiblePanel = ({ title, open, onToggle, children }) => {
    return (
        <Panel>
            <Header
                type="button"
                onClick={onToggle}
                aria-expanded={open}
                data-umami-event="Panel toggled"
                data-umami-event-panel={title}
            >
                <Title>{title}</Title>
                <Divider />
                <Chevron $open={open}>
                    <svg
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <polyline points="6 9 12 15 18 9" />
                    </svg>
                </Chevron>
            </Header>
            {open && <Body>{children}</Body>}
        </Panel>
    );
};

export default CollapsiblePanel;
